import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McdRbtLineList = ({ mcdRbtId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (!mcdRbtId) return;

      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('mcdRbtId', mcdRbtId));
    },
    [mcdRbtId],
  );

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
  };

  return <EntityList entity="MCD_RBT_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />;
};
